import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  role_id: [
    rules.required,
  ],
  user_id: [
    rules.required,
  ],
};
